import { createProductActions } from '@elab/core/store/product/actions';

import types from './types';

export default createProductActions(types);
